import { FecThirdPartyFilter } from '../enums/fecThirdPartyFilter'
import { FecThirdPartyRole } from '../enums/fecThirdPartyRole'
import type { FecThirdPartyMapping } from '../types/fecThirdPartyMapping'

interface FilterFecThirdPartyMappingsParams {
  filter: FecThirdPartyFilter
  searchQuery: string
  thirdPartyMappings: FecThirdPartyMapping[]
}

export const filterFecThirdPartyMappings = ({
  filter,
  searchQuery,
  thirdPartyMappings,
}: FilterFecThirdPartyMappingsParams): FecThirdPartyMapping[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase()

  return thirdPartyMappings.filter((mapping) => {
    if (filter === FecThirdPartyFilter.Clients && mapping.role !== FecThirdPartyRole.Client) {
      return false
    }

    if (filter === FecThirdPartyFilter.Suppliers && mapping.role !== FecThirdPartyRole.Supplier) {
      return false
    }

    if (!normalizedQuery) {
      return true
    }

    return (
      mapping.accountNo.toLowerCase().includes(normalizedQuery) || mapping.label.toLowerCase().includes(normalizedQuery)
    )
  })
}
